export const LOGIN_TEXT = `להתחברות`;